import request from "./../utils/request";

export function getRoles(perPage = 25, page = 1) {
    return request({
        url: "/roles/pagination",
        method: "get",
        params: {
            pageCount: page,
            perPage: perPage,
        },
    });
}

export function createRole(data) {
    return request({
        url: "/roles/",
        method: "post",
        data: data,
    });
}

export function updateRole(id, data) {
    return request.put(`/roles/${id}`, data);
}

export function deleteRole(id) {
    return request.delete(`/roles/${id}`);
}

export function getRolesBySiteId(siteId, perPage = 25, page = 1) {
    return request({
        url: `/roles/site/${siteId}/pagination`,
        method: "get",
        params: {
            pageCount: page,
            perPage: perPage,
        },
    });
}
